import React, { useEffect } from 'react';
import {
  Box,
  List,
  ShimmerBox,
} from '@common-fe/common-fe';

import { EmployerReactivationAccountUsage } from '@/modules/employer/components/EmployerReactivation/EmployerReactivationAccountUsage/EmployerReactivationAccountUsage';
import { useEmployerReactivationStore } from '@/modules/employer/components/EmployerReactivation/stores/useEmployerReactivation.store';

import { useEmployerReactivationBankListData } from './hooks/useEmployerReactivationBankListData';
import { useEmployerReactivationBankListModalsStore } from './stores/useEmployerReactivationBankListModals.store';
import { EmployerReactivationBankListHeader } from './EmployerReactivationBankListHeader';
import { EmployerReactivationBankListItem } from './EmployerReactivationBankListItem';
import { EmployerReactivationBankListModals } from './EmployerReactivationBankListModals';
import { EmployerReactivationBankListPlaceholder } from './EmployerReactivationBankListPlaceholder';

interface Props {
  hasFieldErrors?: boolean;
}



const EmployerReactivationBankList: React.FC<Props> = ({ hasFieldErrors }) => {
  const setAddModalVisible = useEmployerReactivationBankListModalsStore((state) => state.setAddModalVisible);
  const { banks, isLoading, isEmpty, options, onEdit, onView } = useEmployerReactivationBankListData();
  const setHasBankAccounts = useEmployerReactivationStore((state) => state.setHasBankAccounts);

  useEffect(() => {
    setHasBankAccounts(!isEmpty);
  }, [isEmpty, setHasBankAccounts]);

  return (
    <>
      {isLoading ? (
        <ShimmerBox height="270px" width="100%" />
      ) : (
        <Box
          data-testid="EmployerReactivationBankList"
          background="module"
          round="container1Round"
          pad="spacing24"
        >
          <EmployerReactivationBankListHeader
            count={banks?.length || 0}
            onAddClick={() => setAddModalVisible(true)}
          />
          {isEmpty ? (
            <EmployerReactivationBankListPlaceholder />
          ) : (
            <>
              <List testId="EmployerReactivationBankList_list">
                <List.Header>
                  <List.Header.Item flex={1.2}>Description</List.Header.Item>
                  <List.Header.Item flex={1.2}>Account Number</List.Header.Item>
                  <List.Header.Item flex={1}>Type</List.Header.Item>
                  <List.Header.Item flex={0.2} />
                </List.Header>
                {banks.map((bank) => (
                  <EmployerReactivationBankListItem
                    key={bank.id}
                    bank={bank}
                    onView={onView}
                    onEdit={onEdit}
                  />
                ))}
              </List>
              
              <EmployerReactivationAccountUsage options={options} hasFieldErrors={hasFieldErrors} />
            </>
          )}
        </Box>
      )}
      
      <EmployerReactivationBankListModals />
    </>
  );
};

export default EmployerReactivationBankList;
export { EmployerReactivationBankList };
